import { baseBackend } from "../../../../api/base/baseUrl";

const RATES_ENTERPRISE_URL = "/api/v2/rates/enterprise";

export async function getRatesEnterpriseByIdRequest(id) {
  const response = await baseBackend.get(`${RATES_ENTERPRISE_URL}/id/${id}`);
  return response.data;
}

export async function createRatesEnterpriseRequest(payload) {
  const response = await baseBackend.post(RATES_ENTERPRISE_URL, payload);
  return response.data;
}

export async function updateRatesEnterpriseRequest(payload) {
  const response = await baseBackend.put(RATES_ENTERPRISE_URL, payload);
  return response.data;
}
